module.exports = __webpack_public_path__ + "static/media/sweet_5_tablet.a0bf3d72.png";